module.exports = __webpack_public_path__ + "img/electronic_enabled.756e6669.svg";